export default function BookMeetingModal({ openModal, setOpenModal }) {
  if (!openModal) return null;

  const inputClass =
    "w-full px-3 py-3 rounded-lg border border-gray-300 text-sm outline-none focus:ring-2 focus:ring-purple-400";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
      
      <div className="relative max-w-[700px] w-full">
        
        {/* CLOSE BUTTON */}
        <button
          onClick={() => setOpenModal(false)}
          className="absolute top-3 right-3 text-gray-600 text-xl z-10"
        >
          ✕
        </button>

        <section className="min-h-[50vh] flex items-center justify-center   py-3 rounded-xl">
          
          <div className="max-w-[900px] w-full text-center">
            
           
            <div className="bg-[#f3f3f3] p-6 md:p-8 rounded-xl shadow-sm">
              
              <form className="grid grid-cols-1 md:grid-cols-2 gap-4">
                
                <input type="text" placeholder="Full Name" className={inputClass} />
                <input type="email" placeholder="Email" className={inputClass} />
                <input type="tel" placeholder="Mobile Number" className={inputClass} />

                <select className={inputClass}>
                  <option>Choose City</option>
                  <option>Bhubaneswar</option>
                  <option>Cuttack</option>
                  <option>Delhi</option>
                </select>

                <div className="relative md:col-span-1">
                  <label className="absolute -top-2 left-3 bg-[#f3f3f3] px-1 text-[11px] text-gray-500">
                    I want to start conversation in
                  </label>

                  <select className={inputClass}>
                    <option>0-3 months</option>
                    <option>3-6 months</option>
                    <option>6-12 months</option>
                  </select>
                </div>

                <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 text-sm">
                  <p>Do you own a plot or land?</p>

                  <div className="flex gap-4">
                    <label className="flex items-center gap-2">
                      <input type="radio" name="land" /> Yes
                    </label>

                    <label className="flex items-center gap-2">
                      <input type="radio" name="land" /> No
                    </label>
                  </div>
                </div>

                <div className="flex items-start gap-2 md:col-span-2 text-[12px] text-gray-600">
                  <input type="checkbox" className="mt-1" />
                  <p>
                    I agree to{" "}
                    <span className="text-purple-600 cursor-pointer">
                      Privacy Policy
                    </span>{" "}
                    and{" "}
                    <span className="text-purple-600 cursor-pointer">
                      Terms & Conditions
                    </span>
                  </p>
                </div>

                <button
                  type="submit"
                  className="md:col-span-2 w-full py-3 rounded-lg text-white text-sm font-medium bg-gradient-to-r from-purple-300 to-purple-500"
                >
                  Submit
                </button>

              </form>
            </div>
          </div>

        </section>
      </div>
    </div>
  );
}